
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container } from "components/common";
import Star from "components/common/Icons/Star";
import Fork from "components/common/Icons/Fork";
import axios from "axios";
import styled from 'styled-components';
import texteditor from '../../../assets/illustrations/texteditor.png'
import filemanager from '../../../assets/illustrations/filemanager.jpg'
import bubble_game from '../../../assets/illustrations/bubblegame.png'
import { Grid, Wrapper } from "./styles";
import { bold } from "chalk";
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

// import { Wrapper, Grid, Item, Content, Stats } from "./styles";

export const Projects = () => {
  const { theme } = useContext(ThemeContext);
  const [repos, setRepos] = useState([]);
  //console.log(process.env.GITHUB_TOKEN);
  const repoarr = ["bubble_game-SOP", "text-editor", "DAuth-Frontend"];
  const finalRepos = []
  useEffect(() => {
    axios
      .get("https://api.github.com/user/repos", {
        params: {
          visibility: "public",
          per_page: 100,
          affiliation: "owner,collaborator",
        },
        headers: {
          Authorization: `token ${process.env.GITHUB_TOKEN}`,
        },
      })
      .then((response) => response.data)
      .then((repoData) => {
        var i;
        //console.log(repoData);
        repoData.map((a) => {
          for (i = 0; i < 5; i++) if (repoarr[i] === a.name){
            if(a.name==='text-editor') a.image = texteditor;
            if(a.name==='Nodejs-File-Manager') a.image = filemanager;
            if(a.name==='bubble_game-SOP') a.image = bubble_game;
            if(a.name==='DAuth-Frontend'){
              a.name = "DAuth";
              a.svn_url = "https://auth.delta.nitt.edu";
              a.image = "https://delta.nitt.edu/images/deltaLogoGreen.png";
              a.description = "An authentication portal for the students of NIT Trichy. Developed using SvelteJS, Typescript and Webpack. Implemented client registration using Oauth2-server library."
            }
            finalRepos.push(a);
          }
        }
        );
        let temp ={
          name:'Research Portal, NITT',
          description:'An admin project which aims to allow professors and scholars to manage research projects. Developed using django and reactjs framework along with tailwindcss, docker and postgresql.',
          image:"https://pbs.twimg.com/profile_images/1071465359180390401/V-xD2dRH.jpg",
          svn_url:'https://research.nitt.edu'
        }
        finalRepos.push(temp);
        //console.log(repoData,finalRepos);
        //repoData = repoData.slice(0, 8);
        setRepos(finalRepos);
      })
      .catch((error) => console.log(error));
  }, []);



  const DisplayOver = styled.div({
    height: "100%",
    left: "0",
    position: "absolute",
    top: "0",
    width: "100%",
    zIndex: 2,
    transition: "background-color 350ms ease",
    backgroundColor: "transparent",
    padding: "20px 20px 0 20px",
    boxSizing: "border-box",
  });

  const BigTitle = styled.h2({
    textTransform: "uppercase",
    textDecoration:"none",
    fontSize:"1.3rem",
    color: theme === 'light' ? '#212121' : '#fff'
  });

  const SubTitle = styled.h4({
    fontFamily: "Helvetica",
    transform: "translate3d(0,50px,0)",
    transition: "transform 350ms ease",
  });

  const Paragraph = styled.p({
    transform: "translate3d(0,50px,0)",
    transition: "transform 350ms ease",
    fontSize: "1.3rem",
    fontWeight:bold,
  });

  const CTA = styled.a({
    position: "absolute",
    bottom: "20px",
    left: "20px",
  });

  const Hover = styled.div({
    opacity: 0,
    transition: "opacity 350ms ease",
  });
  const Heading = styled.h1({
    fontSize:"3rem",
    color:`rgb(228 93 93) !important`,
    '@media(max-width: 700px)': {
      fontSize: '1.5rem'
    }
  });

  const Background = styled.div({
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    color:`${theme === "light" ? "#000" : "#fff"}`,
    position: "relative",
    width: "100%",
    height: "100%",
    minHeight: "300px",
    minWidth: "300px",
    cursor: "pointer",
    Hover:{
      opacity:0.2
    },
    [`:hover ${DisplayOver}`]: {
      backgroundColor: "rgba(0,0,0,.5)",
    },
    [`:hover ${SubTitle}, :hover ${Paragraph}`]: {
      transform: "translate3d(0,0,0)",
    },
    [`:hover ${Hover}`]: {
      opacity: 1,
    },
    [`:hover ${BigTitle}`]:{
      color:"white"
    }
  });

  return (
    <Wrapper as={Container} id="projects">
      {repos.length > 0 && <Heading>Projects</Heading>}
      <Grid id="Grid">
        {repos.map((node) => (
                      <ScrollAnimation animateIn="animate__zoomIn" duration="3" >
          <div>
          <Background
            key={node.id}
            as="div"
            //href={node.svn_url}
            target="_blank"
            rel="noopener noreferrer"
            theme={theme}
            style={{"backgroundImage":`url(${node.image})`}}
          >
            <DisplayOver>
              <Hover>
                <Paragraph
                style={{"color":`white`}}
                >
                  {node.description}
                </Paragraph>
                <CTA>
                </CTA>
              </Hover>
            </DisplayOver>
          </Background>
          <BigTitle theme={theme} as="a" href={node.svn_url}>{node.name}</BigTitle></div>
          </ScrollAnimation>
        ))}
      </Grid>
    </Wrapper>
  );
};
